import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import pb from "../services/pocketbase";
import { pocketBaseErrorMessage } from "../auth/errors";

/**
 * Confirms signup / email verification from PocketBase token (onMailerRecordVerificationSend link).
 * Routes: /confirm-verification/:token (avoid /auth/ in dev — see setupProxy).
 */
export default function ConfirmVerification() {
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const [detail, setDetail] = useState("");

  const token = useMemo(() => {
    const q = searchParams.get("token");
    const p = params?.token;
    return String(p || q || "").trim();
  }, [params, searchParams]);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      if (!token) {
        setStatus("error");
        setDetail("Invalid or missing confirmation link.");
        return;
      }

      try {
        await pb.collection("users").confirmVerification(token);
      } catch (err) {
        if (cancelled) return;
        setStatus("error");
        setDetail(pocketBaseErrorMessage(err));
        return;
      }

      if (cancelled) return;
      setStatus("success");
      setDetail("Your email is confirmed. You can sign in.");
      setTimeout(() => navigate("/", { replace: true }), 2200);
    })();

    return () => {
      cancelled = true;
    };
  }, [token, navigate]);

  return (
    <div style={{ padding: "2rem", maxWidth: 720, margin: "0 auto" }}>
      <h2 style={{ marginBottom: "0.5rem" }}>
        {status === "loading" && "Confirming your email…"}
        {status === "success" && "Email confirmed"}
        {status === "error" && "Could not confirm email"}
      </h2>
      <p style={{ opacity: 0.9 }}>
        {status === "loading" && "Please wait."}
        {(status === "success" || status === "error") && detail}
      </p>
    </div>
  );
}
